import { isRichTextEmpty } from 'helpers/richText';
/**
 * The store info button opens SaleItemViewer. Without a summary or a
 * description, that modal only shows the title. Product cards also count an
 * image; option rows do not (`textOnly`).
 */
export function saleItemHasViewerContent(item, lang, options) {
    var _a, _b, _c;
    if (!item) {
        return false;
    }
    if (!(options === null || options === void 0 ? void 0 : options.textOnly) && item.image) {
        return true;
    }
    const translation = (_a = item.translations) === null || _a === void 0 ? void 0 : _a.find((entry) => entry.language.code === lang);
    const summary = (_b = translation === null || translation === void 0 ? void 0 : translation.summary) !== null && _b !== void 0 ? _b : item.summary;
    const description = (_c = translation === null || translation === void 0 ? void 0 : translation.infos) !== null && _c !== void 0 ? _c : item.infos;
    return !isRichTextEmpty(summary) || !isRichTextEmpty(description);
}
